import React from "react";

export const themeOptions = [
  { value: "light", text: "Light" },
  { value: "dark", text: "Dark" },
  { value: "system", text: "System" }
] as const;

export type Theme = (typeof themeOptions)[number]["value"] | undefined;
export const useTheme = (
  currentTheme?: Theme
): {
  theme: Theme;
  changeTheme: (newTheme: Theme) => void;
} => {
  const [theme, setTheme] = React.useState<Theme>(currentTheme || "system");

  React.useEffect(() => {
    if (currentTheme) {
      setTheme(currentTheme);
    } else if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  }, [currentTheme]);

  const changeTheme = (newTheme: Theme) => {
    setTheme(newTheme);
  };

  React.useEffect(() => {
    if (theme === "system") {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        document.body.dataset.theme = "dark";
      } else {
        document.body.dataset.theme = "light";
      }
    } else {
      document.body.dataset.theme = theme ?? undefined;
    }
  }, [theme]);

  return { theme, changeTheme };
};
